
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { CookieComponent } from "@/assets/ts/components";
import { Menu } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { formatUserMenu } from "@/utils/userMenuUtil";
import { translateI18n } from "@/utils/stringUtils";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });


    const hasActiveChildren = (match) => {
      if (match) return route.path.split("/").includes(match);
      else return false;
    };
    const MenuConfig = ref(MainMenuConfig);
    const store = useStore();

    const translate = (text) =>{
      return translateI18n(text)
    }
    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      MenuConfig,
      version,
      translate,
      store,
    };
  },
  mounted() {
   /*  this.store
      .dispatch(Menu.findNavTree, {
        'userName': CookieComponent.get("userName"),
        'system': 3,
      })
      .then(async (res1) => {
        if (res1.code == 200) {
          const data = res1.data;
          await localStorage.removeItem("MainMenuConfig");
          localStorage.setItem(
            "MainMenuConfig",
            JSON.stringify(
              formatUserMenu(data, CookieComponent.get("userTypeId"))
            )
          );          
        }
      }); */
    this.MenuConfig = JSON.parse(
      localStorage.getItem("MainMenuConfig") as string
    );
  },
});
